export default __webpack_public_path__ + "static/example-3d04d0549bc7e7ea7deb48f473594bb0.jpeg";